export class ProjectInformation1073Layout {
	public sections = [
		{
			title: 'Information',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectDataSource'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPUDUnitTypes'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPUDUnitTypesOtherDescription'
						}
					}
				]
			]
		},
		{
			title: 'General Description',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementStoriesCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectElevatorCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementStructureStatus'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementPropertyBuiltYear'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEffectiveAgeDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementExteriorWallsMaterial'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementRoofSurfaceMaterial'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCarStorageParkingSpacesCount'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCarStorageSpacesToUnitsRatioNumber'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCarStorageDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCarStorageGuestParkingSpacesCount'
						}
					}
				]
			]
		},
		{
			title: 'Subject Phase',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectSubjectPlannedUnitsCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectSubjectCompletedUnitsCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectSubjectUnitsForSale'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectSubjectUnitsSoldCount'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectSubjectUnitsRentedCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectSubjectOwnerOccupiedUnitCount'
						}
					}
				]
			]
		},
		{
			title: 'If Project Completed',
			items: [
				[
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCompleteTotalPhasesCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCompleteCompletedUnitsCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCompleteUnitsForSaleCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCompleteUnitsSoldCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCompleteUnitsRentedCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCompleteOwnerOccupiedUnitCount'
						}
					}
				]
			]
		},
		{
			title: 'If Project Incomplete',
			items: [
				[
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectIncompleteTotalPhasesCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectIncompletePlannedUnitsCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectIncompleteUnitsForSaleCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectIncompleteUnitsSoldCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectIncompleteUnitsRentedCount'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectIncompleteOwnerOccupiedUnitCount'
						}
					}
				]
			]
		},
		{
			title: 'Project',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectPrimaryOccupancyType'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVDeveloperControlsProjectManagementIndicator',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectManagementType'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectManagementAgentName'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectConcentratedOwnershipIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectConcentratedOwnershipDescription',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectClassificationTypeConversionIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectConversionOriginalUseDescription',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsCompletedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsStatusDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommercialSpaceIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommercialSpaceDescription'
						}
					}
				]
			]
		},
		{
			title: 'Conditions',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectConditionAndQualityDescription'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsLeasedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsLeaseTermsDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisGroundRentIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisGroundRentAmount'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisGroundRentDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCarStorageAdequateIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCarStorageAdequacyEffectOnMarketabilityDescription'
						}
					}
				]
			]
		}
	];
}